import styled from 'styled-components'

export const ActionsContainer = styled.div`
	display: flex;
	gap: 8px;
	margin-left: 12px;
	align-items: center;
`

export const ActionButton = styled.button`
	background: #4f46e5;
	border: none;
	border-radius: 8px;
	width: 36px;
	height: 36px;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	font-size: 16px;
	transition: all 0.2s ease;

	&:hover {
		background: #4338ca;
		transform: translateY(-1px);
	}

	&:active {
		transform: translateY(0);
	}
`